import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

/**
 * Shared TanStack Query client.
 *
 * The retry policy is the part worth stating: a `4xx` is never retried. Retrying a rejected login,
 * a failed CSRF check, or a `404` cannot succeed and only multiplies the load and the audit noise.
 * Server-side failures get two attempts, which covers a redeploy or a brief network blip.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status < 500) return false;
          return failureCount < 2;
        },
        // Dashboard data is cheap to refetch and stale data here is confusing rather than
        // harmless: a revoked key still showing as active would be actively misleading.
        staleTime: 10_000,
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
